import { put, call } from "redux-saga/effects";
import api from "../Services/Api/api";
import PActions from "../Stores/redux/Persist/Actions";

export function* fetchMyProfile() {
  try {
    const { user } = yield call(() => api.get("v1/user/self"));

    if (user) yield put(PActions.setPScreenState("user", { user }));
    else throw new Error("Something went wrong");
  } catch (error) {
    console.warn("Error fetching myProfile: ", error.message);
  }
}
